<template>
  <div id="app">
    <!-- <keep-alive include="index">
      
    </keep-alive> -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body,
#app {
  position: relative;
  width: 100%;
  height: 100%;
}
.amap-logo, .amap-copyright {
  display: none!important;;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue